export const centros = [
    {
        casilla: 1,
        distrito: 1,
        plantel: 'CONALEP PLANTEL 130 DURANGO',
        direccion: 'CALLE SELENIO ESQ. CON ESTAÑO, COL. CD. INDUSTRIAL, C.P. 34208,DURANGO, DGO.'

    },
    {
        casilla: 2,
        distrito: 1,
        plantel: 'CENDI" JOSÉ REVUELTAS"',
        direccion: 'DOROTEO ARANGO S/N, COL. JOSE REVUELTAS, C.P. 34219, DURANGO, DGO.'
        
    },
    {
        casilla: 3,
        distrito: 1,
        plantel: 'ESCUELA PRIMARIA "EVA SAMANO DE LÓPEZ MATEOS"',
        direccion: 'ARGENTINA, S/N, COL. ADOLFO LOPEZ MATEOS, C.P. 34210, DURANGO, DGO.'
        
    },
    {
        casilla: 4,
        distrito: 1,
        plantel: 'COBAED PLANTEL O1 "LA FORESTAL"',
        direccion: 'CALLE SAN MIGUEL DE CRUCES, S/N, FRACC. LA FORESTAL, C.P. 34217'
        
    },
    {
        casilla: 5,
        distrito: 1,
        plantel: 'JARDIN DE NIÑOS "SRA DIANA LAURA RIOJAS REYES"',
        direccion: 'AV. LOS CIPRESES 236, COL. EL CIPRES, C.P. 34217, DURANGO, DGO.'
        
    },
    {
        casilla: 6,
        distrito: 1,
        plantel: 'ESCUELA SECUNDARIA GENERAL "JAIME TORRES BODET"',
        direccion: 'CALLE DEL RIEL S/N, COL. 16 DE SEPTIEMBRE, C.P. 34390 34030, DURANGO, DGO.'
        
    },
    {
        casilla: 7,
        distrito: 1,
        plantel: 'ESCUELA PRIMARIA "QUINCE DE MAYO"',
        direccion: 'COSTA RICA S/N, COL. LAZARO CARDENAS, C.P. 34390 34019, DURANGO, DGO.'
        
    },
    {
        casilla: 8,
        distrito: 1,
        plantel: 'ESCUELA PRIMARIA "DRA. MARGARITA GÓMEZ PALACIO"',
        direccion: 'AV. DEL SOL 301, COL. LUZ Y ESPERANZA, C.P. 34390 34017, DURANGO, DGO.'
    },
    {
        casilla: 9,
        distrito: 1,
        plantel: 'ESCUELA PRIMARIA "LIC. ADOLFO LÓPEZ MATEOS"',
        direccion: 'CALLE DIVISIÓN DEL NORTE, SIN NÚMERO, LOCALIDAD JOSÉ MARÍA MORELOS LA TINAJA, C.P. 34390 DURANGO, DURANGO,'
        
    },
    {
        casilla: 10,
        distrito: 2,
        plantel: 'COBAED PLANTEL 34 "VILLAS DEL GUADIANA"',
        direccion: 'DENEB, S/N, FRACC. VILLAS DEL GUADIANA VII, C.P. 34224, DURANGO, DGO.'
        
    },
    {
        casilla: 11,
        distrito: 2,
        plantel: 'ESCUELA SECUNDARIA "PENSAMIENTO LIBERAL"',
        direccion: 'AV. ESTAÑO 100, COL. CD. INDUSTRIAL, C.P. 34229, DURANGO, DGO'
        
    },
    {
        casilla: 12,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "JOSÉ LORETO BARRAZA"',
        direccion: 'VIA LACTEA, S/N, COL. VILLAS DEL GUADIANA II, C.P. 34224, DURANGO, DGO.'
    },
    {
        casilla: 13,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "LUIS DONALDO COLOSIO"',
        direccion: 'CALLE NUBE ASCENDENTE, S/N. COL. LAS NUBES, C.P. 34224, DURANGO, DGO.'
    },
    {
        casilla: 14,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "EMANCIPACIÓN PROLETARIA"',
        direccion: 'AV. JOSE ANTONIO RAMIREZ S/N, FRACC. FIDEL VELAZQUEZ I, C.P. 34229, DURANGO, DGO.'
    },
{
        casilla: 15,
        distrito: 2,
        plantel: 'ESCUELA SECUNDARIA "LIC. JESUS REYES HEROLES"',
        direccion: 'AV. ESTAÑO ESQ. CON SIGMA, S/N, COL. BOSQUES DEL VALLE, C.P. 34227, DURANGO, DGO.'
    },{
        casilla: 16,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "CHIMALPOPOCA"',
        direccion: 'LABERINTO DE LA SOLEDAD, S/N, COL. OCTAVIO PAZ, 34234, DURANGO, DGO.'
    },{
        casilla: 17,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "FERNANDO MONTES DE OCA"',
        direccion: 'HACIENDA DE SUCHIL, S/N, COL. LA HACIENDA, C.P. 34238, DURANGO, DGO.'
    },{
        casilla: 18,
        distrito: 2,
        plantel: 'ESCUELA SECUNDARIA TECNICA NO. 67 "JOSÉ SANTOS VALDEZ"',
        direccion: 'AV. LAS AMERICAS, S/N, FRACC. GUADALUPE, C.P. 34220, DURANGO, DGO.'
    },{
        casilla: 19,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "LUIS MOYA"',
        direccion: 'ANDADOR SERVICIOS PUBLICOS 107, FRACC. GUADALUPE INFONAVIT, C.P. 34220, DURANGO, DGO.'
    },{
        casilla: 20,
        distrito: 2,
        plantel: 'ESCUELA PRIMARIA "PROF. MÁXIMO GAMIZ FERNÁNDEZ"',
        direccion: 'LITIO 200, COL. LUIS ECHEVERRIA, C.P. 34250, DURANGO, DGO.'
    },{
        casilla: 21,
        distrito: 3,
        plantel: 'UNIVERSIDAD TECNOLÓGICA DE DURANGO',
        direccion: 'CARR. DURANGO-MEZQUITAL S/N LOC GABINO SANTILLAN, DURANGO, DGO.'
    },{
        casilla: 22,
        distrito: 3,
        plantel: 'CECYTED 20 "DOLORES HIDALGO"',
        direccion: 'DOMICILIO CONOCIDO, LOC. DOLORES HIDALGO C.P. 34300 DURANGO, DGO.'
    },{
        casilla: 23,
        distrito: 3,
        plantel: 'CETAC 07',
        direccion: 'CAMINO AL POBLADO 15 DE SEPTIEMBRE 201 EJIDO 15 DE SEPTIEMBRE C.P. 34305, DURANGO, DGO.'
    },{
        casilla: 24,
        distrito: 3,
        plantel: 'ESCUELA SECUNDARIA GENERAL NO. 9',
        direccion: 'PICO PERDIGUERO, S/N, FRACC. PIRINEOS, DURANGO, DGO.'
    },{
        casilla: 25,
        distrito: 3,
        plantel: 'ESCUELA SECUNDARIA TÉCNICA NO. 86',
        direccion: 'LERDO DE TEJADA S/N COL. VILLAS DEL MANANTIAL, C.P. 34198, DURANGO DGO.'
    },{
        casilla: 26,
        distrito: 3,
        plantel: 'ESCUELA SECUNDARIA 450',
        direccion: 'EJERCITO TRIGARANTE 309, COL. BICENTENARIO, C.P. 34168, DURANGO, DGO.'
    },{
        casilla: 27,
        distrito: 3,
        plantel: 'C.B.T.A. No. 3',
        direccion: 'BLVD. PEDRO AVILA NEVAREZ 900 COL. EL ENSUEÑO C.P. 34194, DURANGO DGO.'
    },{
        casilla: 28,
        distrito: 3,
        plantel: 'ESCUELA PRIMARIA "PROF. SALVADOR CAMACHO PEÑA"',
        direccion: 'PRIV, DE FRESNO, S/N, COL. VALLE VERDE SUR, C.P. 34194, DURANGO, DGO.'
    },{
        casilla: 29,
        distrito: 3,
        plantel: 'ESCUELA PRIMARIA "JOSÉ MARÍA MORELOS Y PAVÓN"',
        direccion: 'CALLE INSUGENTES S/N COL. MORELOS SUR, C.P. 34197, DURANGO DGO.'
    },{
        casilla: 30,
        distrito: 3,
        plantel: 'UNIVERSIDAD POLITÉCNICA',
        direccion: 'CARRETERA URANGO-MÉXICO KM 9.5 LOC. DOLORES HIDALGO, C.P. 34300, DURANGO DGO.'
    },{
        casilla: 31,
        distrito: 3,
        plantel: 'CECYTED 07 "COL. HIDALGO"',
        direccion: 'CARLOS A MADRAZO, S/N, LOC. COL. HIDALGO'
    },{
        casilla: 32,
        distrito: 3,
        plantel: 'ESCUELA PRIMARIA "SOLIDARIDAD"',
        direccion: 'SANTA ELENA S/N COL. SAN CARLOS, C.P. 34168 DURANGO. DGO'
    },{
        casilla: 33,
        distrito: 4,
        plantel: 'ESCUELA SECUNDARIA TÉCNICA NO. 19',
        direccion: 'AV. VICENTE GUERRERO S/N COL. INSURGENTES, C.P. 34130, DURANGO DGO.'
    },{
        casilla: 34,
        distrito: 4,
        plantel: 'CECYTED 19 "LLANO GRANDE"',
        direccion: 'KM 77 CARRETERA LIBRE DURANGO LOC. LLANO GRANDE'
    },{
        casilla: 35,
        distrito: 4,
        plantel: 'C.B. T.I.S. No.89',
        direccion: 'CALLE PROLONGACIÓN GERONIMO HERNANDEZ S/N COL. FRANCISCO VILLA, C.P. 34130, DURANGO DGO.'
    },{
        casilla: 36,
        distrito: 4,
        plantel: 'ESCUELA SECUNDARIA "LUIS DONALDO COLOSIO MURRIETA"',
        direccion: 'AV CEDRO S/N COL. DURANGO NUEVO II, C.P. 34188, DURANGO DGO.'
    },{
        casilla: 37,
        distrito: 4,
        plantel: 'COBAED PLANTEL 32 "PROFA. JUANA VILLALOBOS"',
        direccion: 'CARR. A LA FERRERIA KM 0.5 FRENTE AL CAMPESTRE, C.P. 34307, DURANGO DGO.'
    },{
        casilla: 38,
        distrito: 4,
        plantel: 'TELESECUNDARIA NO. 29 "RICARDO CASTRO"',
        direccion: 'DOM. CONOCIDO SEBASTIAN LERDO DE TEJADA, C.P. 34330, DURANGO DGO.'
    },{
        casilla: 39,
        distrito: 4,
        plantel: 'ESCUELA PRIMARIA "DOROTEO ARANGO"',
        direccion: 'CALLE PENSAMIENTO SIN LOC. LA FERRERIA, C.P. 34330, DURANGO DGO.'
    },{
        casilla: 40,
        distrito: 4,
        plantel: 'JARDIN DE NIÑOS "JOSÉ FERNANDO RAMÍREZ"',
        direccion: 'CALLE PRINCIPAL S/N LOC. EL REFUGIO, C.P. 34340, DURANGO DGO.'
    },{
        casilla: 41,
        distrito: 4,
        plantel: 'ESCUELA PRIMARIA "LIC BENITO JUÁREZ"',
        direccion: 'CALLE SINALOA 320 COL IV CENTENARIO, C.P. 34150, DURANGO DGO.'
    },{
        casilla: 42,
        distrito: 4,
        plantel: 'COBAED 33 "JOSÉ MARÍA PINO SUÁREZ"',
        direccion: 'CARRETERA AL MEZQUITAL KM 25 LOC. JOSÉ MARÍA PINO SUÁREZ'
    },{
        casilla: 43,
        distrito: 5,
        plantel: 'ESCUELA SECUNDARIA "BENITO JUÁREZ"',
        direccion: 'CALLE BLAS CORRAL ENTRE ELORREAGA S/N COL. ZONA CENTRO C.P. 34000, DURANGO DGO.'
    },{
        casilla: 44,
        distrito: 5,
        plantel: 'INSTITUTO TECNOLÓGICO DE DURANGO',
        direccion: 'BLVD. FELIPE PESCADOR 1830 COL. NUEVA VIZCAYA, C.P. 34080, DURANGO DGO.'
    },{
        casilla: 45,
        distrito: 5,
        plantel: 'ESCUELA SECUNDARIA TÉCNICA 53',
        direccion: 'CALLE CIPRES Y ENRIQUE CARROLA S/N FRACC. LOS ALAMOS, C.P. 34299, DURANGO DGO.'
    },{
        casilla: 46,
        distrito: 5,
        plantel: 'ESCUELA PRIMARIA "PROFRA. GUADALUPE PATONI DE RUEDA"',
        direccion: 'CALLE DOLORES BELTRAN S/N COL. VALLE DEL GUADIANA, C.P. 34166'
    },{
        casilla: 47,
        distrito: 5,
        plantel: 'ESCUELA PRIMARIA ECOLOGICA "MARÍA DEL REFUGIO BENITEZ ROMO"',
        direccion: 'CALLE CASTAÑA S/N FRACC. NOGALES, C.P. 3416, DURANGO DGO'
    },{
        casilla: 48,
        distrito: 5,
        plantel: 'C.B.T.J.S. No. 130',
        direccion: 'CALLE XICOTENCATL 204 FRACC. LAS FUENTES, C.P. 34170, DURANGO DGO.'
    },{
        casilla: 49,
        distrito: 5,
        plantel: 'ESCUELA SECUNDARIA TÉCNICA 57',
        direccion: 'CALLE UXMAL S/N COL. AZCAPOTZALCO, C.P. 34160, DURANGO DGO.'
    },{
        casilla: 50,
        distrito: 5,
        plantel: 'ESCUELA PRIMARIA "BRUNO MARTÍNEZ"',
        direccion: 'CALLE PINO SUAREZ S/N COL. ZONA CENTRO, C.P. 34000, DURANGO DGO.'
    },{
        casilla: 51,
        distrito: 5,
        plantel: 'ESCUELA PRIMARIA "MIGUEL ÁNGEL DE QUEVEDO"',
        direccion: 'CALLE PALOMA 101 COL. ZONA CENTRO, C.P. 34000, DURANGO DGO.'
    },{
        casilla: 52,
        distrito: 6,
        plantel: 'C.E.T.I.S. No. 148',
        direccion: 'PLUTARCO ELÍAS CALLES 100 COL. JOSÉ LÓPEZ PORTILLO C.P. 34010, DURANGO, DGO.'
    },{
        casilla: 53,
        distrito: 6,
        plantel: 'ESCUELA PRIMARIA "RICARDO CASTRO"',
        direccion: 'CARLOS SANTAMARIA S/N COL. LAS PALMAS C.P. 34014, DURANGO, DGO.'
    },{
        casilla: 54,
        distrito: 6,
        plantel: 'ESCUELA SECUNDARIA GRAL NO. 8 "PROF. ULISES NEVAREZ VARGAS"',
        direccion: '19 DE MAYO S/N COL. AMPLIACIÓN MIGUEL DE LA MADRID C.P. 34046 DURANGO, DGO.'
    },{
        casilla: 55,
        distrito: 6,
        plantel: 'ESCUELA PRIMARIA "MIGUEL HIDALGO"',
        direccion: 'CALLE CRISANTEMO S/N COL LA VIRGEN, C.P. 34049, DURANGO DGO'
    },{
        casilla: 56,
        distrito: 6,
        plantel: 'ESCUELA PRIMARIA ANEXA A LA NORMAL',
        direccion: 'CALZADA LA NORMAL S/N COL. ZONA CENTRO, C.P. 34000 DURANGO DGO.'
    },{
        casilla: 57,
        distrito: 6,
        plantel: 'ESCUELA DE CIENCIAS Y TECNOLOGÍA',
        direccion: 'CALLE PREDIO CANOAS S/N, ESQUINA CON BLVD. DOLORES DEL RIO, COL. ZONA CENTRO C.P. 34076, DURANGO DGO.'
    },{
        casilla: 58,
        distrito: 6,
        plantel: 'COBAED PLANTEL 09 "LOMAS"',
        direccion: 'AV. CAMINO DEL PARQUE S/N FRACC. VISTA HERMOSA C.P. 34100, DURANGO DGO.'
    },{
        casilla: 59,
        distrito: 6,
        plantel: 'TELESECUNDARIA NO. 118 "ENRIQUE W. SANCHEZ"',
        direccion: 'CALLE DEL CIPRES S/N COL. EL SALTITO, C.P. 34105, DURANGO DGO.'
    },{
        casilla: 60,
        distrito: 6,
        plantel: 'ESCUELA PRIMARIA "FANNY ANITUA"',
        direccion: 'RÍO BALSAS 607 COL. VALLE DEL SUR C.P. 34120 DURANGO, DGO.'
    },{
        casilla: 61,
        distrito: 6,
        plantel: 'ESCUELA SECUNDARIA 49 "DR. CARLOS GRAEF FERNÁNDEZ"',
        direccion: 'ROCÍO DE LA MAÑANA S/N COL. ARCO IRIS, C.P. 34127 DURANGO, DGO'
    },{
        casilla: 62,
        distrito: 'ESPECIAL',
        plantel: 'PASEO DURANGO',
        direccion: 'FELIPE PESCADOR S/N COL ESPERANZA C.P. 34080, DURANGO, DGO.'
    },{
        casilla: 63,
        distrito: 'ESPECIAL',
        plantel: 'PLAZA DE ARMAS',
        direccion: 'AV 20 DE NOVIEMBRE S/N ZONA CENTRO C.P. 34000 DURANGO, DGO.'
    },{
        casilla: 64,
        distrito: 'ESPECIAL',
        plantel: 'PARQUE GUADIANA',
        direccion: 'FANNY ANITUA S/N LOS ÁNGELES C.P. 34076 DURANGO, DGO.'
    }
]